import HttpService from "./http-service";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { Paginated } from "@/pagination";
import EthnicGroup from "../entities/ethinc-groups";

export default class EthnicGroupervice extends HttpService {
  public getAllEthnicGroups(): LazyAsyncIter<Paginated<EthnicGroup>> {
    const reqIter = new AsyncPaginatedRequest<EthnicGroupDTO>(
      "get",
      "ethnic-groups",
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();

    return new LazyAsyncIter(reqIter).map((page) => ({
      ...page,
      pageElements: page.pageElements?.map(EthnicGroupFromDTO),
    }));
  }
}

export interface EthnicGroupDTO {
  id: number;
  name: string;
}

export function EthnicGroupFromDTO(dto: EthnicGroupDTO): EthnicGroup {
  return new EthnicGroup({
    id: dto.id,
    name: dto.name,
  });
}
